
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Nantes dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Nantes certifiée Google Partner, aide les entreprises nantaises à accroître leur notoriété et à conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Nantes dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Nantes certifiée Google Partner, aide les entreprises nantaises à accroître leur notoriété et à conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
